module.exports = "<span *ngIf='type; else nothing'>\r\n  <i class=\"fa {{icon}}\" aria-hidden=\"true\"></i>\r\n  <span *ngIf=\"showText\">{{ nameResourceKey | translate }}</span>\r\n</span>\r\n<ng-template #nothing>\r\n  <span *ngIf=\"showText\">{{ 'modules.editors.nothing.name' | translate }}</span>\r\n</ng-template>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/presentations/widgets/widgetButton.component.html
// module id = ./src/app/views/presentations/widgets/widgetButton.component.html
// module chunks = main